import React from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import { Item } from '../../../common/snippets'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import * as id from './../common/AcountingId'
import * as lb from './../common/AcountingLables'
import { Box, Button } from '@mui/material'
import DropDownOA from '../../../common/dropDownOA'
import Datepicker from '../../../common/datePicker'
import moment from 'moment'
import { RefreshSvg } from '../../../common/svg/refresh'
import { SplitButton } from '../../../common/SplitButton'
import { AcountingHeading } from './../common/AcountingHeading'
import { appendToUrl, focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../common/helper'
import { getPartyCreditLimitSummaryData, getOwnChildBranches, getReportBranchList } from '../../../../store/reports/reports_action'
import { getPartyConfigTableData } from '../../../../store/generalSetting/GSAction'
import { useEffect } from 'react'
import * as URL from '../../Reports/oldReportsUrls'
import { getBranchConfigOrEwbillinfo, updateAlertError } from '../../../../store/common/common_action'
import TableViewCreditSummary from './TableViewPartyCreditLimitSummary'
import TableViewCreditSummaryNew from './TableViewPartyCreditLimitSummaryNew'
import { GetRequest, PostRequest, PostRequestCachedV3 } from '../../../common/api'
import { urls } from '../../../common/constants'
const CreditSummaryReport = (props) => {
  const {
    data: { common, reports, generalSettingReducer },
    getPartyCreditLimitSummaryData,
    getPartyConfigTableData,
    updateAlertError,
    getOwnChildBranches,
  } = props
  const { partyConfigTableData } = generalSettingReducer
  const { ownChildBranches1, partyCreditLimitSummaryReportData } = reports
  const { loginData, roleRights } = common
  const reportName = 'Party Credit Limit Summary'
  const [stateList, setStateList] = useState([])
  const [sourceCityList, setSourceCityList] = useState([])
  const [selState, setSelState] = useState([])
  const [selSourceCity, setSelSourceCity] = useState([])
  //const [selParty, setSelSourceBranch] = useState()
  const [selView, setSelView] = useState({ id: 0, name: 'Old Summary' })
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [isExpanded, setIsExpanded] = useState(false)
  const [resetFlag, setResetFlag] = useState(false)
  const [filterSourceCityList, setFilterSourceCityList] = useState([])
  const [disableBtn, setDisableBtn] = useState(false)
  const [selParty, setSelParty] = useState([])

  const viewList = [
    { id: 0, name: 'Old Summary' },
    { id: 1, name: 'New Summary' },
  ]
  useEffect(() => {
    focusElemnt(id.creditSummaryFromDate)
  }, [])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      let object = {
        intPartyID: 0,
        intCompanyID: loginData?.intCompanyID,
        strPartyName: "",
        strContactPerson: "",
        intCityID: 0,
        intIsCreditParty: -1,
        intIsActive: -1,
        intIsDeleted: -1
      }
      getPartyConfigTableData(object)
      const branchData = {
        intUserID: loginData?.intUserID,
        intCompanyID: loginData?.intCompanyID,
        intIsActive: 1,
      }
      getOwnChildBranches(branchData, true, 24 * 60 * 60 * 1000)
    }
  }, [loginData])
  useEffect(() => {
    if (!isEmpty(roleRights) && !isEmpty(loginData)) {
      setDisableBtn(
        !(
          roleRights?.Table1?.[0]?.AllowViewAllBranchReport ||
          roleRights?.Table1?.[0]?.AllowBranchInchargeRights ||
          loginData?.IsBranchAdmin ||
          loginData?.IsMTPLAdmin ||
          loginData?.IsAdmin
        )
      )
      //setDisableExcel(!(roleRights?.Table1?.[0]?.AllowExportExcel))
    }
  }, [roleRights, loginData])
  useEffect(() => {
    if (!isEmpty(ownChildBranches1)) {
      if (ownChildBranches1?.length > 0) {
        let data = []
        let data1 = []
        ownChildBranches1?.map((val, i) => {
          data.push({ StateID: val?.StateID, StateName: val?.StateName })
          data1.push({ CityName: val?.CityName, CityID: val?.CityID, StateID: val?.StateID })
        })
        setStateList(data)
        setSourceCityList(data1)
        setFilterSourceCityList(data1)
        //deafultValue
        setSelState({
          StateName: ownChildBranches1.filter((obj) => obj.CityID === loginData?.intBranchCityID)[0]?.StateName,
          StateID: ownChildBranches1.filter((obj) => obj.CityID === loginData?.intBranchCityID)[0]?.StateID,
        })
        setSelSourceCity({ CityName: loginData?.strCityName, CityID: loginData?.intBranchCityID })
      } else {
        setStateList([])
        setSourceCityList([])
        setSelState('')
        setSelSourceCity('')
      }
    }
  }, [ownChildBranches1])
  const handleClick1 = () => {
    if (selState == '' || selState == ' ') {
      updateAlertError({ show: true, msg: 'Select State', nextId: '' })
    }
    else if (selSourceCity == '' || selSourceCity == ' ') {
      updateAlertError({ show: true, msg: 'Select City', nextId: '' })
    }
    else if (selParty == '' || selParty == ' ') {
      updateAlertError({ show: true, msg: 'Select Party', nextId: '' })
    }
    else if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'Selected Date Range is More Then One Month', nextId: '' })
    } else {
      setIsExpanded(true)
      const obj = {
        CompanyID: loginData?.intCompanyID,
        PartyID: selParty?.PartyID,
        dtFromDate: fromDate.format('YYYY-MM-DD'),
        dtToDate: toDate.format('YYYY-MM-DD'),
      }
      getPartyCreditLimitSummaryData(obj)
    }
  }
  const handleClick2 = () => {
    let url = URL.partyCreditLimitTransactionReport
    const urlData = URL.partyCreditLimitTransactionReportParams
    urlData.chk = loginData.BusCrsCheckSum
    urlData.intFromCityId = selSourceCity?.CityID
    urlData.intPartyId = selParty?.PartyID
    urlData.FromCity = selSourceCity?.CityName
    urlData.PartyName = selParty?.Party
    urlData.FromDate = fromDate.format('DD-MMM-YYYY')
    urlData.ToDate = toDate.format('DD-MMM-YYYY')
    urlData.intAllowExportToExcel = 1
    urlData.Mode = 5
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }
  const handleStateChange = (stateId) => {
    if (stateId !== 0) {
      const filteredCities = sourceCityList.filter((val) => val.StateID === stateId)
      setFilterSourceCityList(filteredCities)
      setSelSourceCity(filteredCities?.[0] || ' ')
      // const filteredBranch = removeDuplicatesFromArray(sourceBranchList, 'BranchID').filter((val) => val.CityID === filteredCities?.[0]?.CityID || filteredCities?.[0]?.CityID === 0 || val.BranchID === 0)
      // setSelSourceBranch(filteredBranch?.[0] || ' ')
    } else {
      setFilterSourceCityList(sourceCityList)
    }
  }
  function addDaysToDate(date, days) {
    const newDate = new Date(date)
    newDate.setDate(newDate.getDate() + days)
    return newDate.toISOString().split('T')[0] // Returns the date in "YYYY-MM-DD" format
  }
  const selectedSourceCity = (obj) => {
    setIsExpanded(false)
    setSelSourceCity(obj)
    //setSelSourceBranch(removeDuplicatesFromArray(sourceBranchList, 'BranchID').filter((item) => item.CityID === obj?.CityID || obj?.CityID === 0 || item.BranchID === 0)?.[0])
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <AcountingHeading reportName={reportName} />
        <Box sx={sx.reportFlex}>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.selectCompany}
              label={lb.select_company}
              defaultvalue={loginData.strCompanyName}
              disabled={true}
              minWidth="250px"
              width="300px"
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
              GO
            </Button>
          </Item>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              label={`From Booking Date`}
              id={id.creditSummaryFromDate}
              // value={fromDate}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt(id.toDate)
              }}
              startDate={'2022-01-01'}
              endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)} //will return future 1 year date
            />
          </Item>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              label={'To Booking Date'}
              id={id.toDate}
              // value={toDate}
              dateChange={(date) => {
                setToDate(date)
                focusElemnt(disableBtn ? id.creditSummarySplitButton : id.stateId)
              }}
              startDate={'2022-01-01'}
              endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)} //will return future 1 year date
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.stateId}
              label={'Select State'}
              data={removeDuplicatesFromArray(stateList, 'StateID') || []}
              defaultvalue={selState?.StateName}
              idKey={`StateID`}
              dataKey={`StateName`}
              onSelect={(val) => {
                setSelState(val)
                setIsExpanded(false)
                handleStateChange(val.StateID)
              }}
              isObjArr={true}
              //searchPlaceholder={`Search By Report Type`}
              width="310px"
              nextId={id.srcCity}
              prevId={id.toDate}
              resetFlag={resetFlag}
              disabled={disableBtn}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.srcCity}
              label={'Select City'}
              data={removeDuplicatesFromArray(filterSourceCityList, 'CityID') || []}
              defaultvalue={selSourceCity?.CityName}
              idKey={`CityID`}
              dataKey={`CityName`}
              onSelect={(obj) => selectedSourceCity(obj)}
              isObjArr={true}
              searchPlaceholder={`Search By Report Type`}
              width="310px"
              nextId={id.srcBranch}
              prevId={id.stateId}
              resetFlag={resetFlag}
              disabled={disableBtn}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.srcBranch}
              label={'Select Party'}
              data={partyConfigTableData || []}
              defaultvalue={selParty?.Party || []}
              dataKey={`Party`}
              idKey={`PartyID`}
              onSelect={(val) => {
                setIsExpanded(false)
                setSelParty(val)
              }}
              isObjArr={true}
              searchPlaceholder={`Search By party`}
              width="310px"
              nextId={id.summaryView}
              prevId={id.srcCity}
              resetFlag={resetFlag}
              disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.summaryView}
              label={'Select View'}
              data={viewList || []}
              defaultvalue={selView?.name}
              idKey={`id`}
              dataKey={`name`}
              onSelect={(val) => {
                setIsExpanded(false)
                setSelView(val)
              }}
              isObjArr={true}
              searchPlaceholder={`Search By Report Type`}
              width="310px"
              nextId={id.creditSummarySplitButton}
              prevId={id.srcBranch}
              resetFlag={resetFlag}
              disabled={disableBtn}
            />
          </Item>
          <Item
            sx={sx.itemsx}
            onKeyDown={(e) => navigation3(e, isExpanded ? 'creditSummaryExcelBtn' : id.creditSummaryFromDate, () => handleClick1())}
          >
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              // hideToggle={false}
              id1={id.creditSummarySplitButton}
              prevID={disableBtn ? id.toDate : id.summaryView}
              onClick1={handleClick1}
              onClick2={handleClick2}
            />
          </Item>
          <Item
            sx={{ ...sx.itemsx }}
            onClick={() => {
              setResetFlag(!resetFlag)
            }}
          >
            <RefreshSvg />
          </Item>
        </Box>
      </Item>
      <Item>
        {isExpanded ? (
          selView.id ? (
            <TableViewCreditSummaryNew
              tableData={partyCreditLimitSummaryReportData}
              loginData={loginData}
              fromDate={fromDate}
              toDate={toDate}
              company={loginData?.strCompanyName}
              StateName={selState?.StateName}
              city={selSourceCity?.CityName}
              party={selParty?.Party}
            />
          ) : (
            <TableViewCreditSummary
              tableData={partyCreditLimitSummaryReportData}
              loginData={loginData}
              fromDate={fromDate}
              toDate={toDate}
              company={loginData?.strCompanyName}
              StateName={selState?.StateName}
              city={selSourceCity?.CityName}
              party={selParty?.Party}
            />
          )
        ) : (
          ''
        )}
      </Item>
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  getOwnChildBranches,
  getBranchConfigOrEwbillinfo,
  getReportBranchList,
  getPartyCreditLimitSummaryData,
  getPartyConfigTableData,
  updateAlertError,
}
export default connect(mapStateToProps, mapDispatchToProps)(CreditSummaryReport)
